import React, { forwardRef, MutableRefObject } from 'react';
import { VStack, HStack } from 'native-base';
import { IVStackProps } from 'native-base/lib/typescript/components/primitives/Stack/VStack';
import { useTheme } from '@springbig/shared';

type PanelProps = IVStackProps & {
    children: React.ReactNode;
    row?: boolean;
    hasShadow?: boolean;
    secondary?: boolean;
};

export const Card = forwardRef<HTMLDivElement, PanelProps>(
    ({
        children,
        row = false,
        hasShadow = false,
        secondary = false,
        ...props
    }: PanelProps, ref: MutableRefObject<HTMLDivElement>) => {

        const {
            card,
            card_text,
            radius_md,
            background_secondary,
            card_border_color,
            card_border_size,
        } = useTheme();

        return (
            row ?
                <HStack
                    bg={secondary ? background_secondary : card}
                    color={card_text}
                    p={4}
                    rounded={radius_md}
                    overflow={'clip'}
                    borderWidth={card_border_size}
                    borderColor={card_border_color}
                    shadow={hasShadow ? 2 : null}
                    {...props}
                    ref={ref}
                >
                    { children }
                </HStack>
                :
                <VStack
                    bg={secondary ? background_secondary : card}
                    color={card_text}
                    p={4}
                    rounded={radius_md}
                    overflow={'clip'}
                    borderWidth={card_border_size}
                    borderColor={card_border_color}
                    shadow={hasShadow ? 2 : null}
                    {...props}
                    ref={ref}
                >
                    { children }
                </VStack>
        );
    });

Card.displayName = 'Card';

export default Card;
